<template>
    <SearchLayout
        display-current-url
        display-current-position
        :get-data="readUrlsByDomain()"
        inner-hits-key="prompts_hits"
    >
        <template #filters="{ search }">
            <nl-search-filters
                input-key="urlSearch"
                name="site"
                :placeholder="$t('searchform.enterDomain').toString()"
                url-search
                @search="search"
            />
        </template>
        <template #errors="{ props: { filters, loading, hasError } }">
            <div v-if="loading" class="box p-5" style="position: relative">
                <b-loading :active="loading" :is-full-page="false" />
            </div>
            <b-notification v-else-if="hasError" active :closable="false" type="is-danger is-light">
                {{ $t('error.message.default') }}
            </b-notification>
            <b-notification v-else-if="filters?.urlSearch" active :closable="false" type="is-info is-light">
                {{ $t('searchform.noArticlesUrl') }}
            </b-notification>
            <b-notification v-else active :closable="false" type="is-secondary is-light">
                {{ $t('searchform.noResultsEnterDomain') }}
            </b-notification>
        </template>
    </SearchLayout>
</template>
<script>
    import NlSearchFilters from '@/components/Search/NlSearchFilters'
    import SearchLayout from '@/components/Search/SearchLayout.vue'
    import elasticUrlsRepository from '@/api/v2/elastic/url'

    export default {
        title: 'searchform.searchByDomain.title',
        name: 'SearchByDomain',
        components: {
            SearchLayout,
            NlSearchFilters
        },
        data: () => ({
            domain: null
        }),
        methods: {
            readUrlsByDomain() {
                return elasticUrlsRepository.readUrlsByDomain
            }
        },
    }
</script>
